var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormStep" } }, [
    _c("div", { staticClass: "form-step-container" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("newWizartV2.formStepTitle"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("label", { staticClass: "display-flex" }, [
              _vm._v(_vm._s(_vm.$t("message.yourName")) + " :"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formValue.name,
                    expression: "formValue.name",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("chatbotv2.name"),
                  autocomplete: "off",
                },
                domProps: { value: _vm.formValue.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formValue, "name", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("label", { staticClass: "display-flex" }, [
                _vm._v(_vm._s(_vm.$t("settings.language")) + " :"),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  ref: "select",
                  style: { width: "300px", height: "50px" },
                  attrs: {
                    size: "large",
                    "show-search": "",
                    placeholder: _vm.$t("newWizartV2.formPlaceholderLanguage"),
                  },
                  model: {
                    value: _vm.formValue.language,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValue, "language", $$v)
                    },
                    expression: "formValue.language",
                  },
                },
                _vm._l(_vm.languages, function (lang) {
                  return _c(
                    "a-select-option",
                    { key: lang.code, attrs: { value: lang.code } },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(lang.name) +
                          "\n                        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("label", { staticClass: "display-flex" }, [
              _vm._v(_vm._s(_vm.$t("coupon.email")) + " :"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                staticStyle: { cursor: "no-drop" },
                attrs: {
                  type: "text",
                  disabled: "",
                  placeholder: _vm.$t("newWizartV2.formPlaceholderEmail"),
                },
                domProps: { value: _vm.user.email },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "display-flex" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.password")) + " :"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.isError ? "input-wrapper error" : "input-wrapper",
                staticStyle: { display: "flex" },
              },
              [
                (_vm.isTextType ? "text" : "password") === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formValue.password,
                          expression: "formValue.password",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t("login.password"),
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.formValue.password)
                          ? _vm._i(_vm.formValue.password, null) > -1
                          : _vm.formValue.password,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.formValue.password,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.formValue,
                                  "password",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.formValue,
                                  "password",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.formValue, "password", $$c)
                          }
                        },
                      },
                    })
                  : (_vm.isTextType ? "text" : "password") === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formValue.password,
                          expression: "formValue.password",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t("login.password"),
                        type: "radio",
                      },
                      domProps: {
                        checked: _vm._q(_vm.formValue.password, null),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.formValue, "password", null)
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formValue.password,
                          expression: "formValue.password",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t("login.password"),
                        type: _vm.isTextType ? "text" : "password",
                      },
                      domProps: { value: _vm.formValue.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.formValue,
                            "password",
                            $event.target.value
                          )
                        },
                      },
                    }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "md-icon",
                    on: { click: _vm.toggleInputType },
                  },
                  [_vm._v("visibility")]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("label", { staticClass: "display-flex" }, [
              _vm._v(_vm._s(_vm.$t("newWizartV2.supsisEntergation"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input-wrapper",
                attrs: { id: "url-input-wrapper" },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("newWizartV2.webUrlScheme"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { url: { require_protocol: false } },
                      expression: "{ url: { require_protocol: false } }",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formValue.webSiteAddress,
                      expression: "formValue.webSiteAddress",
                    },
                  ],
                  attrs: {
                    type: "text",
                    name: "url",
                    placeholder: _vm.$t(
                      "newWizartV2.formPlaceholderSupsisSubdomain"
                    ),
                  },
                  domProps: { value: _vm.formValue.webSiteAddress },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formValue,
                        "webSiteAddress",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "display-flex" }, [
              _vm._v(_vm._s(_vm.$t("message.organizationName")) + " :"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formValue.organizationName,
                    expression: "formValue.organizationName",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("message.organizationName"),
                },
                domProps: { value: _vm.formValue.organizationName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.formValue,
                      "organizationName",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "send-button", on: { click: _vm.nextButtonHandler } },
          [_vm._v(_vm._s(_vm.$t("newWizartV2.goToNextStep")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }